import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import BarberSubscriptions from '../components/BarberSubscriptions';
import { getShopBarbers } from '../reducers';
import { updateSubscription, fetchSubscription } from '../../subscriptions/actions';
import { withPropsOnChange } from 'recompose';
import { getSubscription } from '../../subscriptions/reducers/subscription';

const mapStateToProps = (state, props) => ({
  barbers: getShopBarbers(state, props.params.id),
  barberId: props.params.barberId,
  subscription: getSubscription(state),
});
const mapDispatchToProps = { updateSubscription, fetchSubscription };

const form = reduxForm({
  form: 'updateSubscription',
  enableReinitialize: true,
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    initialValues: {
      enabled: props.subscription ? props.subscription.enabled : false,
    },
  })),
  withPropsOnChange(['barberId'], (props) => {
    if (props.barberId) {
      props.fetchSubscription(props.barberId, 'barber');
    }
  }),
  withHandlers({
    onSubmit: props => data => props.updateSubscription(props.barberId, 'barber', data),
  }),
  form
)(BarberSubscriptions);
